import { Group, Text, ThemeIcon, UnstyledButton } from '@mantine/core';
import IconLogout from '@tabler/icons-react/dist/esm/icons/IconLogout.mjs';
import { useTranslation } from 'react-i18next';
import classes from '../user-button/user-button.module.css';
import { useLogout } from '@/features/authentication';
import cs from 'clsx';

export const Logout = () => {
  const { t } = useTranslation(['translation', 'header']);
  const logout = useLogout();
  return (
    <UnstyledButton
      className={cs(
        classes.user,
        'opacity-60',
        'rounded-[var(--mantine-radius-sm)]',
      )}
      px={'sm'}
      py={'xs'}
      onClick={() => logout()}
    >
      <Group align={'center'} gap={'xs'}>
        <ThemeIcon variant={'transparent'} color={'gray'}>
          <IconLogout />
        </ThemeIcon>
        <Text>{t('header:user.logout')}</Text>
      </Group>
    </UnstyledButton>
  );
};